import React from 'react'

import { PageLoaderProps } from './PageLoaderProps'
import Paragraph from '../../atoms/Paragraph/Paragraph'
import { APP_COLOR, APP_FONT_SIZE } from '../../atoms/AtomsGlobalProps'
import AppLoader from '../../atoms/AppLoader/AppLoader'


import './PageLoaderStyles.scss'


const PageLoader = (props: PageLoaderProps) => {

   const { loadingText = "Daj nam chwilę", ...restLoaderProps } = props

   return (
      <div className='page-loader-wrapper'>
         <AppLoader barWidth={8} height={'var(--loader-size)'} className='page-loader-loader' { ...restLoaderProps }/>
         <Paragraph align='center' size={APP_FONT_SIZE.LARGE} color={APP_COLOR.ACCENT} >
            { loadingText }
         </Paragraph>
      </div>
   )
}

export default PageLoader